<template>
  <v-container>
    <landing-create :content="createQuestionContent"></landing-create>
    <specimen-additional-info-form
      :onSubmit="onSubmit"
    ></specimen-additional-info-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import SpecimenAdditionalInfoForm from './SpecimenAdditionalInfoForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { specimenAdditionalInfoService } = biobankRegistry;

export default {
  name: 'SpecimenAdditionalInfoCreate',
  components: {
    SpecimenAdditionalInfoForm,
    LandingCreate,
  },
  data: () => ({
    specimenAdditionalInfo: {
      name: '',
      hint: '',
      code: '',
      type: '',
    },
    createQuestionContent: {
      pageTitle: 'Create Specimen Info',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      try {
        await specimenAdditionalInfoService.create({ specimenAdditionalInfo: data });
        this.$snackbar.showOk({ text: 'Successfully created Specimen Info!' });
        this.$router.push({ name: 'specimenAdditionalInfo.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
    },
  },
};
</script>
